import { z } from "zod";

export const MAX_SMART_UPLOAD = 20;

export const ANGLE_OPTIONS = [
  { value: "front",  label: "Front"  },
  { value: "side",   label: "Side"   },
  { value: "back",   label: "Back"   },
  { value: "3/4",    label: "3/4"    },
  { value: "top",    label: "Top"    },
  { value: "sole",   label: "Sole"   },
  { value: "detail", label: "Detail" },
  { value: "other",  label: "Other"  },
];

export const editableImageSchema = z.object({
  id: z.string(),
  product_url: z.string(),
  angle: z.string(),
});

export const editableVariantSchema = z.object({
  id: z.string(),
  name: z.string(),
  images: z.array(editableImageSchema),
});

export const editableProductSchema = z.object({
  id: z.string(),
  name: z.string().min(1, "Name is required"),
  sku_code: z.string(),
  category: z.string(),
  confidence: z.number(),
  variants: z.array(editableVariantSchema),
  collapsed: z.boolean(),
});

export const smartUploadFormSchema = z.object({
  products: z.array(editableProductSchema),
});

export type SmartUploadFormValues = z.infer<typeof smartUploadFormSchema>;
export type EditableProduct = z.infer<typeof editableProductSchema>;
export type EditableVariant = z.infer<typeof editableVariantSchema>;
export type EditableImage = z.infer<typeof editableImageSchema>;
export type UploadItem = { file: File; previewUrl: string };
